"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFY_FORM_SUBMIT = exports.NOTIFY_FORM_INPUT = exports.NOTIFY_FORM = void 0;
const NOTIFY_FORM = exports.NOTIFY_FORM = 'notify-form';
const NOTIFY_FORM_INPUT = exports.NOTIFY_FORM_INPUT = 'notify-form-input';
const NOTIFY_FORM_SUBMIT = exports.NOTIFY_FORM_SUBMIT = 'notify-form-submit';